var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:_vm.disabled?'input-v-model-dis':'input-v-model',attrs:{"type":"text","disabled":_vm.disabled,"placeholder":"请输入..."},domProps:{"value":_vm.value},on:{"input":_vm.inputChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }